var map = {
	"./cagayan-cert.webp": 1952,
	"./cert-bg.webp": 1953,
	"./isle-cert.webp": 1954,
	"./license-bg-cn.webp": 1955,
	"./license-bg-mobile-cn.webp": 1956,
	"./license-bg-mobile.webp": 1957,
	"./license-bg.webp": 1958,
	"./pagcor-cert.webp": 1959,
	"./page-bg.webp": 1960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 880;